<template>
  <div class="upgrade-edit">
    <div class="controls">
      <el-form
        ref="upgradeEditForm"
        :rules="rules"
        :model="upgrade"
        label-width="80px"
        size="small"
        style="width: 500px;"
      >
        <el-form-item
          label="试卷名"
          prop="name"
        >
          <el-input v-model="upgrade.name" />
        </el-form-item>

        <el-form-item
          label="适用设备"
          prop="devices"
        >
          <el-checkbox-group
            v-model="upgrade.devices"
            disabled
          >
            <el-checkbox
              label="mobile"
              checked
            >
              <i class="iconfont icon-iphone" />
            </el-checkbox>
            <el-checkbox
              label="pad"
              checked
            >
              <i class="iconfont icon-ipad" />
            </el-checkbox>
            <el-checkbox label="pc">
              <i class="iconfont icon-pc" />
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          label="试卷描述"
          prop="describe"
        >
          <el-input
            v-model="upgrade.describe"
            type="textarea"
          />
        </el-form-item>
      </el-form>

      <div class="add">
        <el-button
          icon="el-icon-plus"
          size="small"
          @click="selectQuestionDialogVisible = true"
        >
          选择试题
        </el-button>
      </div>
    </div>
    <div class="questions">
      <el-table
        :data="questions"
        style="width: 100%;"
      >
        <el-table-column
          label="序号"
          width="80"
          type="index"
        />

        <el-table-column
          label="题型"
          width="150"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.type | questionType }}</span>
          </template>
        </el-table-column>

        <el-table-column label="内容梗概(文本、图片、音频等)">
          <template slot-scope="scope">
            <question-content
              :key="scope.row.uuid"
              :question="scope.row"
            />
          </template>
        </el-table-column>

        <el-table-column
          label="知识点"
          width="250"
        >
          <template slot-scope="scope">
            <question-point
              :key="scope.row.uuid"
              :question="scope.row"
            />
          </template>
        </el-table-column>

        <el-table-column
          label="答案"
          width="90"
        >
          <template slot-scope="scope">
            <question-answer
              :key="scope.row.uuid"
              :question="scope.row"
            />
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          width="200"
        >
          <template slot-scope="scope">
            <div class="btn-move">
              <el-button
                v-if="scope.$index !== 0"
                size="medium"
                type="text"
                @click="movePage(scope.$index, 'up')"
              >
                <i class="el-icon-caret-top" />
              </el-button>

              <el-button
                v-if="scope.$index !== questions.length - 1"
                size="medium"
                type="text"
                @click="movePage(scope.$index, 'down')"
              >
                <i class="el-icon-caret-bottom" />
              </el-button>
            </div>
            <el-button
              size="small"
              type="text"
              @click="removePage(scope.$index)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="operate">
      <el-button
        type="primary"
        size="small"
        @click="save('save')"
      >
        暂存
      </el-button>
      <el-button
        type="success"
        size="small"
        @click="save('check')"
      >
        提审
      </el-button>
      <el-button
        size="small"
        @click="back"
      >
        取消
      </el-button>
    </div>

    <!-- 选题 -->
    <el-dialog
      :visible.sync="selectQuestionDialogVisible"
      width="80%"
    >
      <select-question
        :key="Date.now()"
        :selected="questions"
        :category-id="categoryId"
        :level-id-id="levelId"
        :standard="standard"
        @close="selectQuestions"
      />
    </el-dialog>
  </div>
</template>
<style lang="less" scoped>
.upgrade-edit {
  .controls {
    position: relative;
    .add {
      position: absolute;
      right: 30px;
      bottom: 0;
    }
  }

  .btn-move {
    display: inline-block;
    vertical-align: middle;
    margin: auto 5px;
    button {
      display: block;
      font-size: 22px;
      margin: 0;
      padding: 0;
    }
  }

  .operate {
    margin-top: 20px;
  }
}
</style>

<script>
const debug = require('debug')('ccs:ctrl:upgrade-edit');

import questionContent from '../components/question_content';
import questionAnswer from '../components/question_answer';
import questionPoint from '../components/question_point';
import selectQuestion from '../components/select_question';
import { findIndex, pick } from 'lodash';
import { questionParse } from '../utils';
import axios from 'axios';
import { QUESTION_TYPES } from '../constants';

export default {
	components: {
		selectQuestion,
		questionContent,
		questionAnswer,
		questionPoint
	},
	data() {
		return {
			// 控制属性
			selectQuestionDialogVisible: false,

			rules: {
				name: [
					{ required: true, message: '请输入试卷名称名称', trigger: 'blur' },
					{ max: 100, message: '试卷名称最多 100 个字符', trigger: 'blur' }
				],
				devices: [
					{ required: true, message: '设备不能为空', trigger: 'change' }
				],
				describe: [
					{ max: 500, message: '试卷描述最多 500 个字符', trigger: 'blur' }
				]
			},

			//   数据
			categoryId: 'upgrade',
			levelId: null,
			version: null,
			upgrade: {
				name: '',
				describe: '',
				devices: []
			},
			questions: [],
			standard: null,
		};
	},
	async created() {
		await this.init();
	},
	methods: {
		async init() {
			const { levelId } = this.$route.params;
			const { version, standard } = this.$route.query;
			const upgrade = await axios.get(`/api/up/${levelId}`, {
				params: { version, standard }
			});
			debug('[init] levelId: %s, version: %s', levelId, version);

			this.levelId = levelId;
			this.version = version;
			this.upgrade = upgrade;

			this.questions = upgrade.questions.map(
				({ question }) => questionParse(question)[0]
			);
			this.standard = standard;
		},

		movePage(index, action) {
			debug('[move] index: %s, action: %s', index, action);
			const targetIndex = action === 'up' ? index - 1 : index + 1;
			const currentRow = this.questions[index];
			const targetRow = this.questions[targetIndex];

			this.$set(this.questions, index, targetRow);
			this.$set(this.questions, targetIndex, currentRow);
		},

		removePage(index) {
			debug('[removePage] index: %s', index);
			this.questions.splice(index, 1);
		},

		back() {
			this.$router.replace({
				name: 'upgrade',
				query: { levelId: this.levelId }
			});
		},

		// 暂存
		async save(action = 'save') {
			debug('[save] action: %s, questions: %o', action, this.questions);

			this.$refs['upgradeEditForm'].validate(async valid => {
				if (!valid) return false;
				if (this.questions.length === 0) {
					this.$message({
						showClose: true,
						message: '最少选择一道试题。',
						type: 'error'
					});
					return false;
				}
        
				const standard = this.standard || '';
				let check = true;
				// 判断是否是智能组题，a,B,b三类题，B、b必须一一对应，每个题都可能绑定影子题
				if (standard == '2') {
					// 查询是否有相互绑定的习题
					const questionsLevel = this.questions.filter(question => question['difficulty_question_uuid'] || question['difficulty_question_id']);
					// 找到难题对应的简单题
					questionsLevel.forEach(item => {
						const questionLevel = this.questions.find(question => {
							const findCondition = item.difficulty_question_uuid === question.uuid || item.difficulty_question_id === question.uuid || item.difficulty_question_uuid === question.question_core_id || item.difficulty_question_id === question.question_core_id;
							if (findCondition) return true;
						});

						if (!questionLevel) {
							this.$message({
								showClose: true,
								message: `未找到${item.id}-${QUESTION_TYPES[item.type] || item.type}指定的难题或者简单题。`,
								type: 'error'
							});
							check = false;
						}
					});

					if (!check) return false;
				}

				const { name, describe, devices } = this.upgrade;

				await axios.put(`/api/up/${this.levelId}/${this.version}`, {
					action,
					name,
					describe,
					devices,
					questions: this.questions.map(question => {
						return {
							uuid: question['uuid'] || question['questionUUID'],
							type: question.type,
							isShadow: question['is_shadow'],
							shadowQuestionId: question['shadow_question_id'] // 找到影子题，shadow_question_id = question_core_id
						};
					}),
					standard: this.standard
				});

				this.back();
			});
		},

		selectQuestions(questions) {
			this.selectQuestionDialogVisible = false;
			debug('[selectQuestions] questions: %o', questions);
			if (!questions) return;

			const selected = questions.filter(({ uuid }) => {
				for (const question of this.questions) {
					if (question.uuid === uuid) return false;
				}
				return true;
			});

			this.questions.push(...selected);
		}
	}
};
</script>
